import sweetAlert from 'sweetalert';
import I18n from '../../i18n-js/index.js.erb';
import SidePanel from './sidepanel';

const QuestionsResponsesChanges = {
  start() {
    SidePanel.onUpdate(($sidepanel) => {
      const $forms = $sidepanel.find('.js-questions-responses');
      if (!$forms.length) return;

      $forms.on('ajax:success', this._onSaveSuccess);

      // Cancel button reuses the .toggle-editing handler, which fires
      // a `toggle:editing` event on the .form--inplace card with the new
      // editing state (true=entered, false=exited). When the user exits
      // editing without saving, revert input values to their dirrty
      // initial value and mark the form clean so Close won't warn.
      $sidepanel.find('.form--inplace').on('toggle:editing.qrdirty', this._onToggleEditing);

      // Intercept Close. Registered first because v2.js loads modules
      // alphabetically and questions_responses_changes < sidepanel, so this
      // onUpdate handler runs before SidePanel's, attaching its click
      // listener before SidePanel.reset's listener.
      $sidepanel.find('[data-sidepanel-close]').on('click.qrdirty', (e) => {
        if (this._anyDirty($sidepanel)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this._confirmClose($sidepanel);
        }
      });
    });
  },

  _onSaveSuccess() {
    $('.js-track-responses-table').trigger('datatable:reload');
  },

  _onToggleEditing(e, isEditing) {
    if (isEditing) return;
    const $form = $(e.currentTarget).find('form.js-questions-responses');
    if (!$form.length) return;
    $form.find('input, textarea, select').each(function () {
      const initial = $(this).attr('data-dirrty-initial-value');
      if (initial !== undefined) $(this).val(initial);
    });
    $form.dirrty('setClean');
  },

  _anyDirty($sidepanel) {
    let dirty = false;
    $sidepanel.find('form.js-questions-responses').each(function () {
      if ($(this).dirrty('isDirty')) {
        dirty = true;
        return false;
      }
    });
    return dirty;
  },

  _confirmClose($sidepanel) {
    const scope = 'js.my_events.questions_responses.unsaved_close';
    sweetAlert({
      title: I18n.t(`${scope}.title`),
      text: I18n.t(`${scope}.text`),
      icon: 'warning',
      buttons: [I18n.t('shared.buttons.cancel'), I18n.t(`${scope}.confirm`)]
    }).then((confirmed) => {
      if (!confirmed) return;
      $sidepanel.find('form.js-questions-responses').each(function () {
        $(this).dirrty('setClean');
      });
      SidePanel.reset();
    });
  }
};

export default QuestionsResponsesChanges;
